import { render, staticRenderFns } from "./HRDualTile.vue?vue&type=template&id=636ecf51&scoped=true&"
import script from "./HRDualTile.vue?vue&type=script&lang=js&"
export * from "./HRDualTile.vue?vue&type=script&lang=js&"
import style0 from "./HRDualTile.vue?vue&type=style&index=0&id=636ecf51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636ecf51",
  null
  
)

export default component.exports